import {useState,useEffect, useContext} from 'react';
import { useParams } from 'react-router-dom';
import { Card,CardBody,CardHeader, Row } from 'reactstrap';
import { CabeceraProyecto } from '../../interfaces/CabeceraProyecto';
import { Alert,Container,Grid,LinearProgress,Paper,Stack,TextField,Typography } from '@mui/material';
import { List,ListItemButton,ListItemIcon } from '@mui/material';
import { Tab,Tabs,Box } from '@mui/material';
import axios from 'axios'
import {BiRightArrow} from 'react-icons/bi'
import DatosGeneralesForm from '../DatosGeneralesForm';
import { CasUserContext } from '../../services/casUserContext';
import HideAndSeek from '../../ExitEden/HideAndSeek';
import ProyectoService from '../../services/ProyectoService';
import EventoService from '../../services/EventoService';
import { ImLab } from "react-icons/im";
import { ProyectoEvntDTO } from '../../interfaces/ProyectosDTOS/EventoProyDTO';
import EventosProyTable from './EventosProyTable';
import { MantenimientoPage } from '../../pages/Error/EnMantenimiento';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const proyectoService = new ProyectoService();
const eventoService = new EventoService();
const hideAndSeek = new HideAndSeek();

export function Proyecto() {
  const {idInv,idPro} = useParams();   
  const [value, setValue] = useState<number>(100);
  const [proyecto,setProyecto] = useState<CabeceraProyecto>();
  const [idProyecto,setIdProyecto] = useState(0);
  const [eventosProyecto,setEventosProyecto] = useState<Array<ProyectoEvntDTO>>([]);
  const [evntReady,setEvntReady] = useState(false);
  const casUserContext = useContext(CasUserContext);
  const token = casUserContext.token;
  const user = casUserContext.userData;
  const [isAdmin,setIsAdmin] = useState(false);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
//#region Funciones
  const fetchData = async () =>{
    try{
      let id = parseInt(idPro??'0');
      setIdProyecto(id);
      const response = await proyectoService.GetProyectosByIdProyecto(id,token)
              .then((data) => {
                   //console.log(data);
                   if(data.status.isSuccessfully){
                    setProyecto(data.data);
                   }                  
               })               
              .catch((error) => console.error(error));    
    }catch(error){
      console.error('Error:',error);
    }
  };
  const fetchEventos = async () =>{
    try{
      setEvntReady(false);
      const response = await eventoService.GetEventosByIdProyecto(idProyecto,token)
              .then((data) => {
                   if(data.status.isSuccessfully){
                    //console.log(data.listData);
                    setEventosProyecto(data.listData);
                    setEvntReady(true);
                   }else{
                    setEventosProyecto([]);
                    setEvntReady(true);
                   }                  
               })               
              .catch((error) => console.error(error));    
    }catch(error){
      console.error('Error:',error);
    }
  };
  function cifrarId(id:number):number{
    // Ejemplo de uso
    let book = hideAndSeek.GlobalCipherBookPhrase();
    const numeroCifrado = hideAndSeek.encryptNumber(id, book);
    return numeroCifrado
  }
  function deCifrarId(idCipher:number):number{
    // Ejemplo de uso
    let book = hideAndSeek.GlobalCipherBookPhrase();
    const numeroOriginal = hideAndSeek.decryptNumber(idCipher, book);
    return numeroOriginal;
  }
//#endregion

//#region USEEFFECT
  useEffect(() => {
    fetchData();
    },[]);
//#endregion

    return (
    <Paper elevation={3} >
    <Alert icon={<ImLab fontSize="inherit" />} severity="info">
      <Typography variant="subtitle1" gutterBottom><strong>Menú Proyecto {proyecto?.codigopr}</strong></Typography>
    </Alert>
    <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
    >
    <Grid container spacing={2}>
      <Grid item xs={2} sm={2} md={2} lg={2}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="Datos Generales" {...a11yProps(0)} />
        <Tab label="Cronograma" {...a11yProps(1)} />
        <Tab label="Areas Conocimiento" {...a11yProps(2)} />
        <Tab label="Pertinencia" {...a11yProps(3)} />
        <Tab label="Zona de Delimitación" {...a11yProps(4)} />
        <Tab label="Financiamiento" {...a11yProps(5)} />
        <Tab label="Instituciones Colaboradores" {...a11yProps(6)} />
        <Tab label="Personal" {...a11yProps(7)} />
        <Tab label="Productos Esperados" {...a11yProps(8)} />
        <Tab label="Evidencias del Proyecto" {...a11yProps(9)} /> 
        <Tab label="Eventos" {...a11yProps(10)} onClick={() => {fetchEventos()}}/>        
      </Tabs>
      </Grid>
      <Grid item xs={10} sm={10} md={10} lg={10}>
      <TabPanel value={value} index={100}>
      {proyecto?.autorizadodecana ? 
           <Alert severity="error">           
           Aprobado por el decanato de investigación <br />
           No olvidarse que debe ingresar los respectivos productos terminados al sistema, a medida que los vaya obteniendo.            
       </Alert>
       : <></>  
      }        
          <Typography><strong>Instrucciones</strong></Typography>
          <List sx={{bgcolor: 'background.paper' }}>
                <ListItemButton>
                  <ListItemIcon>
                    <BiRightArrow />
                  </ListItemIcon>
                  <Typography>Ingresar todos los datos requeridos especificados en cada uno de los item del menú.</Typography>
                </ListItemButton>
                <ListItemButton>
                  <ListItemIcon>
                    <BiRightArrow />
                  </ListItemIcon>
                  <Typography>Cuando este seguro de que tiene todos los datos. Seleccione el item <strong>'Enviar a autorizar'</strong> para que el proyecto sea evaluado.</Typography>
                </ListItemButton>
                <ListItemButton>
                  <ListItemIcon>
                    <BiRightArrow />
                  </ListItemIcon>
                  <Typography>Una vez que el proyecto haya sido aprobado por el decanato por el decanato de investigación, se le habilitara una opción para ingresar los <strong>PRODUCTOS TERMINADOS</strong>.</Typography>
                </ListItemButton>                
          </List>
      </TabPanel>
      <TabPanel value={value} index={0}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={2}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={3}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={4}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={5}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={6}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={7}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper> 
      </TabPanel>
      <TabPanel value={value} index={8}>
      <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={9}>
        <Paper sx={{textAlign: 'center' }}>
          <MantenimientoPage />
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={10}>
      {evntReady ?
        <Paper>
          <Row sx={{p:1}}>
          <Typography variant="h5" gutterBottom>
            Eventos del Proyecto
          </Typography>
          <EventosProyTable rowsPerPage={[5 ,10, 25, 100]} data={eventosProyecto} esAdmin={isAdmin}/>
          </Row>
        </Paper>
            :
        <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
          <LinearProgress color="secondary" />
        </Stack>}
      </TabPanel>
      </Grid>
    </Grid>
    </Box>
   </Paper>
  )
}
